/**
 * Контракт REST /v1. Схемы нужны обеим сторонам: сервер сериализует ответ
 * через них, клиент разбирает. Возвращать «просто объект» нельзя - в публичный
 * ответ незаметно уедет служебное поле, и компилятор этого не поймает.
 */
import { z } from 'zod';
import { REGIONS } from './constants';
import { WorldPublicSchema } from './ws';

export const OkSchema = <T extends z.ZodTypeAny>(result: T) =>
  z.object({ ok: z.literal(true), result });

export const FailureSchema = z.object({
  ok: z.literal(false),
  code: z.string(),
  params: z.record(z.string(), z.union([z.string(), z.number(), z.boolean()])).optional(),
});

export const HealthSchema = z.object({
  ok: z.boolean(),
  d1: z.boolean(),
  do: z.boolean(),
  stage: z.string(),
});

export const MetaSchema = z.object({
  apiVersion: z.number().int(),
  dayPayloadVersion: z.number().int(),
  datasets: z.record(z.string(), z.string()),
  /** Какие способы входа реально настроены на этом стенде. */
  auth: z.object({
    emailOtp: z.boolean(),
    google: z.boolean(),
    discord: z.boolean(),
  }),
  worldDefaults: z.object({
    types: z.array(z.string()),
    regions: z.array(z.string()),
    tickMinutes: z.record(z.string(), z.number()),
    defaultTickMinutes: z.number(),
  }),
});

export const RegionSuggestionSchema = z.object({
  suggested: z.enum(REGIONS),
  country: z.string().nullable(),
  city: z.string().nullable(),
});

export const WorldSummarySchema = WorldPublicSchema.extend({
  isMember: z.boolean(),
});

export const WorldStateSchema = z.object({
  world: WorldPublicSchema,
  online: z.number().int().nonnegative(),
  nextTickAt: z.number().int(),
  member: z.boolean(),
});

export const ProfileSchema = z.object({
  userId: z.string(),
  isAnonymous: z.boolean(),
  email: z.string().nullable(),
  handle: z.string().nullable(),
  locale: z.string(),
  region: z.enum(REGIONS).nullable(),
});

export type Health = z.infer<typeof HealthSchema>;
export type Meta = z.infer<typeof MetaSchema>;
export type RegionSuggestion = z.infer<typeof RegionSuggestionSchema>;
export type WorldStateResponse = z.infer<typeof WorldStateSchema>;
export type ProfileResponse = z.infer<typeof ProfileSchema>;
